import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

const IconNumber75Small = createReactComponent('outline', 'number-75-small', 'Number75Small', __iconNode);

export default IconNumber75Small;